import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserPermissions, selectPermissionsLoading, selectArePermissionsLoaded } from '../../modules/user/selectors';
import Loader from '../common/Loader';

interface PermissionRouteProps {
  moduleSlug: string;
  permission?: 'have_read' | 'have_write' | 'have_edit' | 'have_delete' | 'have_admin';
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ 
  moduleSlug, 
  permission = 'have_read' 
}) => {
  const permissions = useSelector(selectUserPermissions);
  const loading = useSelector(selectPermissionsLoading);
  const isLoaded = useSelector(selectArePermissionsLoaded);

  // If loading or if permissions are not yet available (and we haven't hit an error), wait.
  // This handles the gap between MainLayout mounting and fetchUserPermissions starting.
  if (loading || !isLoaded) {
    return <Loader open={true} />;
  }

  const hasPermission = permissions[moduleSlug]?.[permission] || permissions[moduleSlug]?.have_admin;

  if (!hasPermission) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default PermissionRoute;
